import React, { useEffect, useState } from "react";
import styles from "./Contact.module.css";
import FAQItem from "../../Components/CustomerServices/FAQItem";
import ShopActions from "../../Components/Shared/ShopActions/ShopActions";
import SharedCS from "./SharedCS";
import * as FaIcons from "react-icons/fa";
import EnquiryForm from "../../Components/CustomerServices/EnquiryForm";
import useContactStore from "../../Stores/useContactStore";
import * as fa from "react-icons/fa";
import { Link } from "react-router-dom";

function Contact() {
  const { contact, getContactDetails } = useContactStore();


  const [showNumber, setShowNumber] = useState(false);
  const showNumberHandler = async () => {
    if (Object.keys(contact).length === 0) {
      await getContactDetails();
    }
    setShowNumber(true);
  };

  const handleWhatsApp = () => {
    if (!contact?.PhoneNumber) {
      alert("Phone number not available.");
      return;
    }

    const phoneNumber = contact?.PhoneNumber; // Use the phone number from the contact details
    const message = ""; // Customize the message as needed
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(url, "_blank");
  };

  
  return (
    <div>
      <SharedCS
        Title="Contact Us"
        Icon={<FaIcons.FaPhoneAlt className={styles.ContactUs} />}
      />
      <div className={styles.ContactWrapper}>
        <div className={`${styles.Contactrow} ${styles.ContactEmail}`}>
          <div className={styles.method}>EMAIL</div>
          <div className={styles.implementation}>contact@matchhampers.com</div>
        </div>
        <div className={`${styles.Contactrow} ${styles.ContactEmail}`}>
          <div className={styles.method}>INSTAGRAM / FACEBOOK / TIKTOK</div>
          <div className={styles.implementation}>@matchhampers</div>
        </div>
        <div className={`${styles.Contactrow} ${styles.ContactEmail}`}>
          <div className={styles.method}>LinkedIn</div>
          <div className={styles.implementation}>
            <Link
              to="https://www.linkedin.com/company/matchhampers/"
              target="_blank"
              className={styles.LinkedInLink}
            >
              https://www.linkedin.com/company/match-hampers
            </Link>
          </div>
        </div>
        <div className={`${styles.Contactrow} ${styles.ContactEmail}`}>
          <div className={styles.method}>PHONE</div>
          <div className={styles.implementation}>
            {showNumber ? (
              <div className={styles.PhoneNumberWrapper}>
                <div className={styles.PhoneNumber}>
                  +{contact?.PhoneNumber}
                </div>
                <button className={styles.WhatsApp} onClick={handleWhatsApp}>
                  Click to WhatsApp
                  <fa.FaWhatsapp className={styles.WhatsAppIcon} />
                </button>
              </div>
            ) : (
              <button className={styles.WhatsApp} onClick={showNumberHandler}>
                Show Number
              </button>
            )}
          </div>
        </div>
        <div className={`${styles.Contactrow} ${styles.ContactEmail}`}>
          <div className={styles.method}>IN-PERSON</div>
          <div className={styles.implementation}>
            Find out about markets/pop-ups on our social pages.
          </div>
        </div>
      </div>
      <ShopActions />
    </div>
  );
}

export default Contact;
